import React, { useEffect, useState } from "react";
import { FaEdit } from "react-icons/fa";
import { CiCamera } from "react-icons/ci";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import uploadFiles from "../common/UploadFiles";
import { update_seller_profile } from "../../hook/useapi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

// seller_status is set by the admin review (Pending / Approved / Suspended / Rejected)
const SELLER_STATUS = {
  approved: { label: "Verified", badge: "bg-[#1DA1F2]" },
  rejected: {
    label: "Rejected",
    badge: "bg-[#BE1F2E]",
    note: "*Your seller verification was not approved",
  },
  suspended: {
    label: "Suspended",
    badge: "bg-[#BE1F2E]",
    note: "*Your store is currently suspended",
  },
  pending: {
    label: "Verification Pending",
    badge: "bg-yellow-400",
    note: "*Your details have been submitted for verification",
  },
};

const BannerProfile = ({ profiledate }) => {
  const sellerStatus =
    SELLER_STATUS[String(profiledate?.seller_status || "").toLowerCase()] || SELLER_STATUS.pending;

  const [backgroundprofile, setBackgroundprofile] = useState(
    "/image/backgroundprofile.png"
  );
  const [profilePreview, setProfilePreview] = useState("/image/profilepic.png");
  const [coverFile, setCoverFile] = useState(null);

  useEffect(() => {
    if (profiledate?.cover_image?.url) {
      setBackgroundprofile(profiledate.cover_image.url);
    }
    if (profiledate?.profile_image?.url) {
      setProfilePreview(profiledate.profile_image.url);
    }
  }, [profiledate]);

  const handleImageUpload = async (e, fieldName) => {
    const file = e.target.files[0];
    if (!file) return;

    // ✅ show preview
    const previewUrl = URL.createObjectURL(file);
    if (fieldName === "cover_image") {
      setBackgroundprofile(previewUrl);
    } else if (fieldName === "profile_image") {
      setProfilePreview(previewUrl);
    }

    try {
      // ✅ upload file
      const uploaded = await uploadFiles([file]);
      const imageData = {
        url: uploaded[0].url,
        media_type: file.type,
      };

      // ✅ send dynamic body
      const body = {
        seller_id: String(profiledate?.id),
        [fieldName]: imageData,
      };

      const resp = await axios.post(
        `${API_BASE_URL}/seller/update-seller-profile`,
        body,
        {
          headers: {
            token: sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );
      console.log(`${fieldName} updated:`, resp);

      toast.success(
        `${
          fieldName === "cover_image" ? "Cover" : "Profile"
        } image updated successfully!`
      );
    } catch (error) {
      console.error(`Error uploading ${fieldName}:`, error);
      toast.error(`Failed to upload ${fieldName.replace("_", " ")}!`);
    }
  };
  return (
    <div>
      <div className="relative rounded-lg py-4">
        {/* Cover Image Section */}
        <div className="w-full h-[100px] sm:h-[320px] rounded-lg overflow-hidden relative group">
          <input
            type="file"
            accept="image/*"
            id="cover-upload"
            className="hidden"
            onChange={(e) => handleImageUpload(e, "cover_image")}
          />

          <label className="cursor-pointer block">
            <img
              src={backgroundprofile}
              alt="Cover"
              className="w-full h-[100px] sm:h-[280px] object-cover group-hover:opacity-80 transition"
            />
          </label>

          <label
            htmlFor="cover-upload"
            className="absolute top-3 right-3 bg-white px-3 py-1 text-xs font-medium rounded-full shadow cursor-pointer"
          >
            <span className="flex items-center gap-1">
              <FaEdit className="text-sm" />
              Edit Cover
            </span>
          </label>
        </div>

        {/* Profile Image Section */}
        <div className="relative mt-3 sm:mt-0 sm:absolute sm:right-auto sm:-bottom-9 sm:left-6">
          <div className="flex items-start sm:items-center">
            <div className="relative shrink-0 p-1 rounded-2xl sm:rounded-3xl bg-gradient-to-br from-[#F5D90A] to-[#1DE78B] shadow">
              <input
                type="file"
                accept="image/*"
                id="profile-upload"
                className="hidden"
                onChange={(e) => handleImageUpload(e, "profile_image")}
              />
              <label
                htmlFor="profile-upload"
                className="block w-[70px] h-[70px] sm:w-[160px] sm:h-[160px] rounded-xl sm:rounded-[20px] overflow-hidden bg-white cursor-pointer group"
              >
                <img
                  src={profilePreview}
                  alt="Profile"
                  className="w-full h-full object-cover group-hover:opacity-80 transition"
                />
              </label>
              <label
                htmlFor="profile-upload"
                className="absolute bottom-2 right-2 bg-white rounded-full p-1 shadow cursor-pointer"
              >
                <CiCamera className="text-base sm:text-xl text-gray-700" />
              </label>
            </div>
            {profiledate && (
              <div className="min-w-0 ml-3 sm:mt-20 sm:ml-5">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                  <p className="text-lg font-semibold">{profiledate.name || profiledate.store_name}</p>
                  <p
                    className={`flex gap-1 items-center text-[10px] text-white py-1 px-[7px] rounded-xl ${sellerStatus.badge}`}
                  >
                    <RiVerifiedBadgeFill className="text-[15px]" />
                    {sellerStatus.label}
                  </p>
                </div>
                {profiledate.user?.username && (
                  <p className="text-sm text-gray-500 break-all">@{profiledate.user.username}</p>
                )}
                {sellerStatus.note && (
                  <p className="text-[#BE1F2E] font-medium italic text-[13px] pt-1">
                    {sellerStatus.note}
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerProfile;
